export default "__VITE_ASSET__DoZLvMJH__"